/**
 * Application version - imported from package.json (single source of truth)
 */
import { version } from '../../package.json';

export const VERSION = version;
